module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/BIOPHYSICS-cdb5f644a36068715ecde58b35b299d4.png";